import { useBrowserTitle } from '@acp/core-ui';
import { SettingsPage } from '../features/settings/page';

export function Settings() {
    useBrowserTitle('Settings');

    return <SettingsPage />;
}
